import { useMediaQuery } from "@mui/material";
import i18n from "i18next";

import { useActions } from "../../../hooks/use-actions";

import { LinkStyled, Span } from "./Logo.styled";

export const Logo = () => {
  const language = i18n.language;
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up("md"));
  const { setMenu } = useActions();

  return (
    <LinkStyled
      onClick={() => {
        if (!isLargeScreen) {
          setMenu(false);
        }
      }}
      to={language === "en" ? "/" : language}
    >
      <Span>Unlocklab</Span>
    </LinkStyled>
  );
};
